import React, { Component } from 'react'
import Swiper from 'react-id-swiper'
import 'react-id-swiper/lib/styles/css/swiper.css'
import '../../utils/css/styles.css'

export default class Navigation extends Component {
  render() {
    const { images = [], imageContain = false } = this.props
    const params = {
      loop: true,
      effect: 'fade',
      pagination: {
        el: '.swiper-pagination',
      },
      clickable: true,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    }

    return (
      <Swiper {...params}>
        {images.map((src, index) => (
          <div className="swiper-slide" key={index}>
            <img
              src={src}
              style={imageContain ? { objectFit: 'contain' } : {}}
              alt={`Header Slider ${index + 1}`}
            />
          </div>
        ))}
        {/*
					<div>
					<img src={hero08} alt="Header Slider 8" />
				</div>
				<div>
					<img src={hero10} className="img-fluid" alt="Header Slider 10" />
				</div>
				<div>
					<img src={hero11} className="img-fluid" alt="Header Slider 11" />
				</div>
					<div>
					<img src={hero13} className="img-fluid" alt="Header Slider 13" />
				</div>
				<div>
					<img src={hero15} className="img-fluid" alt="Header Slider 15" />
				</div><div>
          <img src={hero17} className="img-fluid" alt="Header Slider 17" />
        </div>*/}
      </Swiper>
    )
  }
}
